import analyticsInstances, {
  getFallbackAnalyticsInstanceId
} from '../../../analyticsInstances';
import { type SupportedIntegrationProductSlugs } from '../../../constants';
import type { SendIssueEventArgs } from '../../../ejectable/hooks/useSendToIntegrationLogic';

enum SendIssueEvent {
  Success = 'success',
  Fail = 'fail',
  Initiate = 'initiate'
}

type AnalyticsData = {
  integration: SupportedIntegrationProductSlugs;
  project: string;
  issueType: string;
  template: string;
  multiple: boolean;
};

type EventHandlers = Record<SendIssueEvent, (data: AnalyticsData) => void>;

const reportSendIssueAnalyticEvent = (
  event: SendIssueEvent,
  args: SendIssueEventArgs
) => {
  const analytics =
    analyticsInstances[
      getFallbackAnalyticsInstanceId(args.integrationProductSlug)
    ];

  const data: AnalyticsData = {
    integration:
      args.integrationProductSlug as SupportedIntegrationProductSlugs,
    project: args.project,
    issueType: args.issueType,
    template: args.template,
    multiple: args.isMultipleShare || false
  };

  const eventHandlers: EventHandlers = {
    [SendIssueEvent.Success]: successArgs =>
      analytics.integrationIssueSendSuccess(successArgs),
    [SendIssueEvent.Fail]: failArgs =>
      analytics.integrationIssueSendFail(failArgs),
    [SendIssueEvent.Initiate]: initiateArgs =>
      analytics.integrationIssueSendClick(initiateArgs)
  };

  eventHandlers[event](data);
};

export const reportSendIssueFailed = (args: SendIssueEventArgs) =>
  reportSendIssueAnalyticEvent(SendIssueEvent.Fail, args);

export const reportSendIssueSuccess = (args: SendIssueEventArgs) =>
  reportSendIssueAnalyticEvent(SendIssueEvent.Success, args);

export const reportSendIssueInitiate = (args: SendIssueEventArgs) =>
  reportSendIssueAnalyticEvent(SendIssueEvent.Initiate, args);
